export default import.meta.ROLLDOWN_FILE_URL_9z1s6pW3kLVSBTb1N9y2Uw